import { appStorage } from "./appStorage";
import {
  clearTourPendingFirstOpen,
  markFirstTimeTourCompleted,
} from "../components/common/TourGuideModal";

export const POST_SIGNUP_INTRO_ACTIVE_KEY = "phonebook_post_signup_intro_active_v1";
export const POST_SIGNUP_AWAIT_CONTACT_KEY = "phonebook_post_signup_await_contact_v1";
export const OPEN_INTRODUCTION_ONBOARDING_EVENT = "phonebook:open-introduction-onboarding";
export const POST_SIGNUP_INTRO_FINISHED_EVENT = "phonebook:post-signup-intro-finished";

export const isPostSignupIntroActive = () => {
  try {
    return appStorage.getItem(POST_SIGNUP_INTRO_ACTIVE_KEY) === "true";
  } catch {
    return false;
  }
};

export const shouldRedirectToContactAfterProfile = () => {
  try {
    return appStorage.getItem(POST_SIGNUP_AWAIT_CONTACT_KEY) === "true";
  } catch {
    return false;
  }
};

export const clearPostSignupAwaitContact = () => {
  try {
    appStorage.removeItem(POST_SIGNUP_AWAIT_CONTACT_KEY);
  } catch {
    // ignore
  }
};

export const finishPostSignupIntro = () => {
  try {
    appStorage.removeItem(POST_SIGNUP_INTRO_ACTIVE_KEY);
  } catch {
    // ignore
  }
  try {
    window.dispatchEvent(new CustomEvent(POST_SIGNUP_INTRO_FINISHED_EVENT));
  } catch {
    // ignore
  }
};

/**
 * After signup: skip tour modal and open Settings → Introduction instead.
 * Marks first-time tour complete so the old tour auto-open path stays dormant.
 */
export const startPostSignupIntroduction = (navigate) => {
  try {
    appStorage.setItem(POST_SIGNUP_INTRO_ACTIVE_KEY, "true");
    appStorage.setItem(POST_SIGNUP_AWAIT_CONTACT_KEY, "true");
    appStorage.setItem("active_section", "Settings");
    appStorage.setItem("active_setting_subsection", "Introduction");
    appStorage.removeItem("active_introduction_subtab");
    appStorage.removeItem("active_permission_subtab");
  } catch {
    // ignore
  }

  // Prevent Welcome tour modal from opening (tour code kept, just not triggered)
  try {
    markFirstTimeTourCompleted();
    clearTourPendingFirstOpen();
  } catch {
    // ignore
  }

  if (typeof navigate === "function") {
    navigate("/personal-info", { replace: true });
  }

  try {
    window.setTimeout(() => {
      window.dispatchEvent(new CustomEvent(OPEN_INTRODUCTION_ONBOARDING_EVENT));
    }, 50);
  } catch {
    // ignore
  }
};
